import { BaseDto } from './base.dto';

export class ProductAllergenDto extends BaseDto {
  productId: number;
  allergenId: number;
}
